import { Box, Button, Paper, Stack, Tab, Tabs, Typography, useTheme } from "@mui/material"
import React, { useEffect } from "react";
import CustomTabPanel from "../components/CustomTabPanel";
import OpexRules from "../components/reconciliationRules/OpexRules";
import { AFSClassification, PPTClassification, Reconciliation, SocialAccountMapping } from "../helpers/interfaces";

import { getAllAFSClassifications, getAllPPTClassifications, getAllReconciliation } from "../apiServices/CTBMappingKeysApi";
import { ReportType } from "../helpers/constants";
import { CustomTextField } from "../layouts/themes";
import { getAllSocialAccountMapping } from "../apiServices/GTBMappingKeysApi";


function ReconciliationRules() {

    const theme = useTheme();

    const [selectedTabValue, setSelectedTabValue] = React.useState(1);
    const [socialAccountMapping, setSocialAccountMapping] = React.useState<SocialAccountMapping[]>([])
    const [pptClassification, setPPTClassification] = React.useState<PPTClassification[]>([])
    const [reconciliation, setReconciliation] = React.useState<Reconciliation[]>([])
    const [afsClassification, setAFSClassification] = React.useState<AFSClassification[]>([])
    const [year, setYear] = React.useState<string>("")
    const [yearInput, setYearInput] = React.useState<number>(new Date().getFullYear());
    const [copyPPTRules, setCopyPPTRules] = React.useState(false);



    useEffect(() => {
        setYear(String(2025))
        getAllSocialAccountMapping().then(sam => setSocialAccountMapping(sam))
        getAllPPTClassifications().then(ppt => setPPTClassification(ppt))
        getAllReconciliation().then(rec => setReconciliation(rec))
        getAllAFSClassifications().then(afs => setAFSClassification(afs))

    }, [])
    return (
        <>
            <Box m="1.0rem 1.0rem">
                <Stack>
                    <Paper>
                        <Typography fontWeight="bold" sx={{ margin: '1.0rem', color: theme.palette.secondary.main, fontSize: '13px' }}>
                            Reconciliation Rules
                        </Typography>
                    </Paper >
                </Stack>
                <Paper >
                    <Box mt="7px" p='0.5rem' gap="15px">
                        <div>
                            <Tabs
                                variant="fullWidth"
                                value={selectedTabValue}
                                onChange={(event: any, newValue: any) => setSelectedTabValue(Number(newValue))}
                                textColor="secondary"
                                indicatorColor="secondary"
                                aria-label="secondary tabs example"
                                sx={{
                                    fontWeight: 500,
                                    minHeight: '36px',
                                    '& .MuiTab-root': {
                                        minHeight: '36px',
                                        height: '36px',
                                        padding: '6px 12px',


                                        fontWeight: 500
                                    },
                                    '& .MuiTabs-indicator': {
                                        height: '2px'
                                    },
                                    '& .MuiTabs-flexContainer': {
                                        minHeight: '36px'
                                    }
                                }}    >
                                <Tab label="Reconciliation Logic for OPEX" value={1} />
                                <Tab label="Reconciliation Logic for CAPEX" value={2} />
                            </Tabs>
                        </div>
                        <CustomTabPanel value={selectedTabValue} index={1} >
                            <>
                                <div >
                                    {!copyPPTRules &&
                                        <div className='mb-2 '>
                                            <CustomTextField size="small" id="outlined-basic" placeholder="Filter By Year..." value={yearInput} onChange={(e) => setYearInput(Number(e.target.value))} variant="outlined" sx={{ width: '80%' }} />&nbsp;&nbsp;
                                            <Button color='info' variant="contained" onClick={() => setYear(String(yearInput))} style={{ textTransform: 'none', fontSize: 12 }}> Get Reconciliation Rules By Year</Button>

                                        </div>
                                    }
                                    <OpexRules  socialAccountMapping = {socialAccountMapping} copyPPTRules={copyPPTRules} setCopyPPTRules={setCopyPPTRules} setYear={setYear} year={year} reconciliation={reconciliation} pptClassification={pptClassification} afsClassification={afsClassification} reportType={ReportType.OPEX} />
                                </div>
                            </>
                        </CustomTabPanel>
                        <CustomTabPanel value={selectedTabValue} index={2} >
                            <>
                                <div >
                                    {!copyPPTRules &&
                                        <div className='mb-2 '>
                                            <CustomTextField size="small" id="outlined-basic" placeholder="Filter By Year..." value={yearInput} onChange={(e) => setYearInput(Number(e.target.value))} variant="outlined" sx={{ width: '80%' }} />&nbsp;&nbsp;
                                            <Button color='info' variant="contained" onClick={() => setYear(String(yearInput))} style={{ textTransform: 'none', fontSize: 12 }}> Get Reconciliation Rules By Year</Button>

                                        </div>
                                    }
                                    <OpexRules socialAccountMapping = {socialAccountMapping} copyPPTRules={copyPPTRules} setCopyPPTRules={setCopyPPTRules} setYear={setYear} year={year} reconciliation={reconciliation} pptClassification={pptClassification} afsClassification={afsClassification} reportType={ReportType.CAPEX} />
                                </div>
                            </>
                        </CustomTabPanel>
                    </Box>

                </Paper>
            </Box>

        </>
    )
}
export default ReconciliationRules;